import DesktopAwareNotification from "../core-components/DesktopAwareNotification";
import React, {useEffect, useRef, useState} from "react";
import {doc, onSnapshot} from "firebase/firestore";
import {auth, db} from "../../Security/firebase-config";
import {linkMatchToCalendarEvent} from "../../utils/calendarMatchLink";
import EventSetup from "./EventSetup";
import useEventSetupLifecycle from "./useEventSetupLifecycle";

// Used by existing VOD editors as well as link dialogs, not only new uploads.
export default function MatchEventSetup({teamId, mapId, matchId, onTitleChange, disabled = false, onSetupKeyChange, onLineupChange, onAttachExisting}) {
  const setupLifecycle = useEventSetupLifecycle();
  const [match, setMatch] = useState(null);
  const [selection, setSelection] = useState(null);
  const [ready, setReady] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const setupCallback = useRef(onSetupKeyChange);
  setupCallback.current = onSetupKeyChange;
  const titleCallback = useRef(onTitleChange);
  const lineupCallback = useRef(onLineupChange);
  lineupCallback.current = onLineupChange;
  titleCallback.current = onTitleChange;
  useEffect(() => {
    setMatch(null); setSelection(null); setError("");
    if (!teamId || !mapId || !matchId) return undefined;
    return onSnapshot(doc(db, "teams", teamId, "maps", mapId, "matches", matchId), snap => {
      const data = snap.exists() ? snap.data() : null;
      setMatch(data);
      setupCallback.current?.(data?.calendarEventId || "");
      if (data?.calendarEventId && data.title) titleCallback.current?.(data.title);
    }, () => setError("Could not load the match setup."));
  }, [teamId, mapId, matchId]);
  if (!matchId) return null;
  return <div className="CalendarMatchLinker">
    <EventSetup requireMap lifecycle={setupLifecycle} lineupSeed={match} teamId={teamId} mapId={mapId} mapName={match?.mapName || mapId}
      onAttachExisting={onAttachExisting} attachExistingLabel="Attach existing stats" attachExistingTutorialId={onAttachExisting ? "tutorial.vod-review.team-stats-link" : undefined}
      selectedEventId={match?.calendarEventId || ""} onReadyChange={setReady} disabled={disabled || saving || !match}
      onSelectEvent={(key, event) => {setSelection(event); if (key === match?.calendarEventId && event) {titleCallback.current?.(event.title); if (event.comp) lineupCallback.current?.(event.comp);}}}/>
    {ready && selection && match?.calendarEventId !== selection.eventId && <button type="button" disabled={disabled || saving} onClick={async () => {
      setSaving(true); setError("");
      try {await linkMatchToCalendarEvent({teamId, mapId, mapName: match?.mapName || mapId, matchId, calendarEventId: selection.eventId,
        playedAt: match?.matchPlayedAt || new Date(), actor: {uid: auth.currentUser?.uid, username: auth.currentUser?.displayName || "Member"}});}
      catch (failure) {setError(failure.message || "Could not link this match.");}
      finally {setSaving(false);}
    }}>Link match to selected event</button>}
    {error && <DesktopAwareNotification as="p" role="alert">{error}</DesktopAwareNotification>}
  </div>;
}
